import { Ability } from "../core/abilities/Ability";

const abilities = {
  drawOne: {
    advancesTurn: true,
    target: {
      type: "self",
    },
    effects: [
      {
        letterCount: 1,
      },
    ],
  },
  drawFull: {
    advancesTurn: true,
    target: {
      type: "self",
    },
    effects: [
      {
        letterCount: 20,
      },
    ],
  },
  sustain: {
    advancesTurn: false,
    target: {
      type: "self",
      prompt: "lettersPrompt",
      promptProps: { max: 3, min: 3 },
    },
    effects: [
      {
        wandLetterRemoval: true,
        statAdjustments: [{ stat: "hunger", type: "gain", amount: 3 }],
      },
    ],
  },
  selfTrash: {
    advancesTurn: false,
    target: {
      type: "self",
      prompt: "trashLettersPrompt",
      promptProps: { max: 4 },
    },
    effects: [
      {
        wandSwapLetters: true,
        statAdjustments: [{ stat: "hunger", type: "lose", amount: 1 }],
      },
    ],
  },
  cycle: {
    advancesTurn: false,
    target: {
      type: "self",
      prompt: "lettersPrompt",
      promptProps: { max: 10, min: 1 },
    },
    effects: [
      {
        wandSwapLetters: true,
      },
    ],
  },
  freeEntry: {
    target: {
      type: "self",
    },
    effects: [
      {
        grantFreeEntry: true,
        setNoTrigger: true,
      },
    ],
  },

  placeBlock: {
    target: {
      type: "target",
      distance: 4,
      passableOnly: true,
      noNeighbors: true,
      prompt: "letterSelect",
      promptProps: {
        title: "Place Letter",
        description: "Select a Letter to place",
        max: 1,
      },
    },
    effects: [
      {
        wandLetterRemoval: true,
        placeLetters: true,
      },
    ],
  },
  duplicateBlock: {
    target: {
      type: "target",
      distance: 4,
      passableOnly: true,
      noNeighbors: true,
      prompt: "letterSelect",
      promptProps: {
        title: "Duplicate Letter",
        description: "Select a Letter to duplicate",
        max: 1,
      },
    },
    effects: [
      {
        placeLetters: true,
      },
    ],
  },
  lettersTwo: {
    target: {
      type: "self",
    },
    effects: [
      {
        letterCount: 2,
      },
    ],
  },
  lettersChug: {
    advancesTurn: true,
    target: {
      type: "self",
    },
    effects: [
      {
        letterCount: 4,
      },
    ],
  },
  simplePoly: {
    target: {
      type: "self",
    },
    effects: [
      {
        changeWordToLength: -1,
      },
    ],
  },
  targetPoly: {
    target: {
      type: "target",
      distance: 4,
    },
    effects: [
      {
        changeWordToLength: -1,
      },
    ],
  },
  weaken: {
    target: {
      type: "target",
      distance: 6,
    },
    effects: [
      {
        weaken: true,
      },
    ],
  },
  hinder: {
    target: {
      type: "target",
      distance: 6,
    },
    effects: [
      {
        weaken: true,
      },
      {
        weaken: true,
      },
      {
        weaken: true,
      },
    ],
  },
  spellMinor: {
    target: {
      type: "self",
    },
    effects: [{ refreshSpells: 1 }],
  },
} as const;

export const AbilityTypes = Object.entries(abilities).reduce(
  (r, [key, value]) => {
    r[key as keyof typeof abilities] = new Ability(key, value);
    return r;
  },
  {} as Record<keyof typeof abilities, Ability>
);
